"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const BreadcrumbsModal_vue_1 = __importDefault(require("./BreadcrumbsModal.vue"));
const BulkDownloader_vue_1 = __importDefault(require("./BulkDownloader.vue"));
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const SamplePill_vue_1 = __importDefault(require("./SamplePill.vue"));
let ModalSamples = class ModalSamples extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.toSearch = '';
        this.visibleRows = new Array();
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    dismissModal() {
        this.$emit('dismissModal');
    }
    onchangesearch(textSearch) {
        this.toSearch = textSearch;
        this.visibleRows = this.configurationOptions.configurationRows.filter((r) => {
            if (this.toSearch.toLowerCase().includes(',') || this.toSearch.toLowerCase().includes(' ') || this.toSearch.toLowerCase().includes('|')) {
                const chunks = this.toSearch.toLowerCase().split(/[\s,|]+/);
                for (const chunk of chunks) {
                    if (r.hook.toLowerCase().includes(chunk.toLowerCase())) {
                        return true;
                    }
                }
            }
            else {
                return (r.hook.toLowerCase().includes(this.toSearch.toLowerCase())) ? true : false;
            }
            return false;
        });
    }
    mounted() {
        this.visibleRows = [...this.configurationOptions.configurationRows];
    }
    updateAvailableRows() {
        this.visibleRows = [...this.configurationOptions.configurationRows];
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], ModalSamples.prototype, "configurationOptions", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], ModalSamples.prototype, "deployed", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], ModalSamples.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('configurationOptions', { immediate: true, deep: true })
], ModalSamples.prototype, "updateAvailableRows", null);
ModalSamples = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            BreadcrumbsModal: BreadcrumbsModal_vue_1.default,
            BulkDownloader: BulkDownloader_vue_1.default,
            Search: bmk_ui_framework_1.Search,
            Button: bmk_ui_framework_1.Button,
            Modal: bmk_ui_framework_1.Modal,
            TableBmk: bmk_ui_framework_1.TableBmk,
            TableHeader: bmk_ui_framework_1.TableHeader,
            TableHeaderCell: bmk_ui_framework_1.TableHeaderCell,
            TableBody: bmk_ui_framework_1.TableBody,
            TableBodyRow: bmk_ui_framework_1.TableBodyRow,
            TableBodyCell: bmk_ui_framework_1.TableBodyCell,
            SamplePill: SamplePill_vue_1.default,
            ViewZero: bmk_ui_framework_1.ViewZero,
            MagnifyingGlassIcon: bmk_ui_framework_1.MagnifyingGlassIcon
        },
    })
], ModalSamples);
exports.default = ModalSamples;
